import * as React from "react";
import DotMenu, { IActionsList } from "../../../components/DotMenu";

export default (actions: (record: any) => IActionsList) => [
  {
    title: "Table name",
    dataIndex: "name",
    sorter: true,
  },

  {
    title: "Status",
    dataIndex: "status",
    sorter: true,
  },
  {
    title: "",
    key: "actions",
    className: "prevent-click",
    render: (text: any, record: any) => (
      <DotMenu actions={actions(record)} record={record} />
    ),
  },
];
